import { RefDirective } from './ref.directive';
import { IFrameComponent } from './iframe.component';
import { XRefDirective } from './xref.directive';
import { SpinnerComponent } from './spinner.component';
import { HSpinnerComponent } from './hspinner.component';

export const scSharedModule = 'sc-shared';

angular.module(scSharedModule, [])
  .directive('scRef', RefDirective)
  .directive('scXref', XRefDirective)
  .component('scIframe', IFrameComponent)
  .component('scSpinner', SpinnerComponent)
  .component('scHspinner', HSpinnerComponent)
;



// WEBPACK FOOTER //
// ./src/shared/shared.module.js